import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "हिं" },
  { code: "mr", label: "मर" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const active = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  const set = (code) => {
    if (code === active) return;
    i18n.changeLanguage(code);
  };

  return (
    <div role="tablist" aria-label="Language" className={`inline-flex rounded-full border border-slate-300 bg-white p-0.5 ${className}`} data-testid="lang-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          role="tab"
          aria-selected={active === l.code}
          onClick={() => set(l.code)}
          className={`h-7 px-2.5 text-[11px] font-semibold rounded-full transition-colors ${
            active === l.code ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"
          }`}
          data-testid={`lang-${l.code}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
